export default "__VITE_ASSET__d298c46a__"